export default __webpack_public_path__ + "static/media/hero-green.ae313133.png";